export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/share-info-popup/share-info-popup.js